<div
  class="collection-header d-flex flex-column"
  [ngClass]="{'padding-info': expanded}"
>

  <div class="d-flex align-self-start">
    <div class="d-flex align-items-center padding-header">
      <div
        *ngIf="isExpandible"
        class="expand-button"
        color="light-natural"
      >
        <mat-icon
          *ngIf="!expanded"
          class="rotate-arrow color-arrow-expandable font-s-icon mat-icon-right"
        >
          arrow_drop_up
        </mat-icon>
        <mat-icon
          *ngIf="expanded"
          class="color-arrow-expandable font-s-icon mat-icon-top"
        >
          arrow_drop_down
        </mat-icon>
      </div>
      <h2
        class="title-shortlist"
        [ngClass]="{
    'mat-subheading-2': !hideFilters
    }"
      >
        Shortlist
      </h2>
    </div>

    <aside *ngIf="showSeeAll">
      <ng-container>
        <a
          class="mat-link mat-body-1 pr-3"
          [routerLink]="['shortlist']"
          routerLinkActive="hidden"
        >See all</a>
      </ng-container>
    </aside>
  </div>

  <div
    class="d-flex justify-content-between width-100"
    [ngClass]="{'padding-b': (currentRoute$ | async) === 'shortlist'}"
  >
    <mat-tab-group
      *ngIf="!hideFilters"
      class="tabs removeMargin"
      (selectedTabChange)="matTabChanged($event)"
    >
      <mat-tab
        label="DIRECT APPLICANTS ({{totalElementsOnList.totalAllCandidates}})"
        aria-label="Direct applicants"
      >
      </mat-tab>
      <mat-tab
        *mojoHasFeatureExtension="prospectsFe"
        label="PROSPECTS ({{totalElementsOnList.totalProspects}})"
        aria-label="Prospects"
      >
      </mat-tab>
    </mat-tab-group>

    <div class="d-flex">
      <mojo-statuses-assign-select
        *ngIf="!hideFilters && radioButtonSelected !== 'Prospects'"
        [statuses]="statuses"
        [isDisabled]="isSelectDisabled"
        (selection)="statusesSelected($event)"
        class="showSelect margin-r"
      >
      </mojo-statuses-assign-select>

      <ng-container *mojoHasFeatureExtension="isHiringManagerFlow">
        <mojo-hiring-manager-statuses
          *ngIf="!hideFilters && radioButtonSelected !== 'Prospects'"
          class="showSelect margin-r"
          (selection)="hmStatusesSelected($event)"
        ></mojo-hiring-manager-statuses>
      </ng-container>

    </div>

    <div class="showFilter">
      <div
        *ngIf="!hideFilters && radioButtonSelected !== 'Prospects'"
        class="filter-icon"
        (click)="open()"
      >
        <mat-icon
          [matBadge]="totalFilterSelected + totalHMFilterSelected"
          [matBadgeHidden]="totalFilterSelected === 0 "
          matBadgeSize="small"
          matBadgeColor="accent"
          data-cy="job-matches-candidateStateCheckboxChanged-list-icon"
        >
          filter_list</mat-icon>
        <div>
          Filter
        </div>
      </div>
    </div>

  </div>
</div>

<mojo-side-nav-filter
  [opened]="sidebarOpened"
  (closed)="close()"
  (clearFilters)="onClearFilters()"
  [totalResults]="totalElements"
>
  <div class="job-filter-portal">
    <ng-container [ngTemplateOutlet]="statusFilter">
    </ng-container>
  </div>
</mojo-side-nav-filter>

<ng-template #statusFilter>
  <div class="d-flex flex-column">
    <mojo-statuses-assign-select
      [statuses]="statuses"
      [isDisabled]="isSelectDisabled"
      (selection)="statusesSelected($event)"
    >
    </mojo-statuses-assign-select>

    <mojo-hiring-manager-statuses
      class="margint-top"
      (selection)="hmStatusesSelected($event)"
    >

    </mojo-hiring-manager-statuses>
  </div>
</ng-template>
